const VISIT_COUNT_KEY = "als_visit_count"
const SESSION_KEY = "als_session_active"
const STATUS_KEY = "als_newsletter_status"

const VISITS_BEFORE_PROMPT = 3

export const NEWSLETTER_STATUS_COOKIE = "als_newsletter"
export const NEWSLETTER_COOKIE_MAX_AGE = 400 * 24 * 60 * 60

export type NewsletterState = "subscribed" | "dismissed"

type NewsletterStatus = {
  state: NewsletterState
  at: number
}

export function recordVisit() {
  if (readSession(SESSION_KEY)) {
    return
  }
  writeSession(SESSION_KEY, "1")
  const count = Number(readLocal(VISIT_COUNT_KEY) || "0") + 1
  writeLocal(VISIT_COUNT_KEY, String(count))
}

export function shouldShowNewsletterPrompt() {
  if (readStatus() || readStatusCookie()) {
    return false
  }
  return Number(readLocal(VISIT_COUNT_KEY) || "0") >= VISITS_BEFORE_PROMPT
}

export function markNewsletterSubscribed() {
  writeStatus({ state: "subscribed", at: Date.now() })
}

export function markNewsletterDismissed() {
  writeStatus({ state: "dismissed", at: Date.now() })
}

function readStatusCookie() {
  const match = document.cookie.match(new RegExp(`(?:^|; )${NEWSLETTER_STATUS_COOKIE}=([^;]*)`))
  if (!match) {
    return null
  }
  return decodeURIComponent(match[1])
}

function readStatus(): NewsletterStatus | null {
  const raw = readLocal(STATUS_KEY)
  if (!raw) {
    return null
  }
  try {
    return JSON.parse(raw) as NewsletterStatus
  } catch {
    return null
  }
}

function writeStatus(status: NewsletterStatus) {
  writeLocal(STATUS_KEY, JSON.stringify(status))
}

function readLocal(key: string) {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

function writeLocal(key: string, value: string) {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    return
  }
}

function readSession(key: string) {
  try {
    return window.sessionStorage.getItem(key)
  } catch {
    return null
  }
}

function writeSession(key: string, value: string) {
  try {
    window.sessionStorage.setItem(key, value)
  } catch {
    return
  }
}
